import { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import useTranslator from "../../../hooks/useTranslator";
import constants from "../../../Utils/constants";
import { haveValue } from "../../../helper/common";
import AuthContext from "../../../context/auth/AuthContext";
import LandLordContext from "../../../context/landlord/LandLordContext";
import LandlordProgressbar from "./LandlordProgressbar";
import { trackClarityEvent } from "../../../Utils/clarityReady";

const DiscoverySourceModal = ({
  progressStep,
  setCurrentStep,
  setFormData,
  formData,
}) => {
  const { updateUserInfo, loadUserTenant, setLoading } =
    useContext(AuthContext);
  const { updateExtraFields } = useContext(LandLordContext);
  const { _t } = useTranslator();
  const cards = [
    {
      id: constants.FRIEND_COLLEAGUE_RECOMMENDATION,
      img: "/images/multiple-user.svg",
      titleKey: "aFriendOrColleagueRecommended",
    },
    {
      id: constants.SEARCHING_GOOGLE,
      img: "/images/google-solid-icon.svg",
      titleKey: "searchingInGoogle",
    },
    {
      id: constants.PODCAST_YOUTUBE,
      img: "/images/podcast-icon.svg",
      titleKey: "podcastOrYoutube",
    },
    {
      id: constants.INSTAGRAM_TIKTOK,
      img: "/images/insta-tiktok-icon.svg",
      titleKey: "instagramOrTikTok",
    },
    {
      id: constants.SAW_EVENT_CONGRESS,
      img: "/images/event-icon.svg",
      titleKey: "iSawYouInAnEventOrCongress",
    },
    {
      id: constants.others,
      img: "/images/bubble-chat.svg",
      titleKey: "other",
    },
  ];
  const [selected, setSelected] = useState(formData.landing_source);

  const handleSubmitForm = () => {
    const send_data = { ...formData, profile_completed: true };
    setLoading(true);
    updateExtraFields(formData)
      .then((res) => {
        updateUserInfo(send_data)
          .then((res) => {
            setCurrentStep((prev) => prev + 1);
            trackClarityEvent("landlord_hear_about_skor_step_ended");
            setTimeout(() => {
              trackClarityEvent("landlord_onboarding_ended");
            }, constants.CLARITY_DELAY);
            let usertype = localStorage.getItem("usertype");
            loadUserTenant(usertype);
          })
          .catch((err) => {
            console.log("Error while updating user info");
          });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleNextStep = () => {
    setCurrentStep((prev) => prev + 1);
  };

  const handlePrevStep = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const handleSelectCard = (card_id) => {
    setSelected(card_id);
    setFormData((prev) => ({ ...prev, landing_source: card_id }));
  };

  return (
    <div>
      <Modal
        show={true}
        // onHide={handleCloseModal}
        centered
        className="landlord-onboarding-modal"
      >
        <Modal.Header>
          <Modal.Title>
            <h4>{_t("whereDidYouHearAboutUs")}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{_t("pleaseSelectAnOption")}</p>
          <LandlordProgressbar step={progressStep + 1} />
          <div className="better-cards-comp">
            {cards.map((card) => (
              <div
                onClick={() => handleSelectCard(card.id)}
                className={`usage-card ${
                  selected === card.id ? "select-card " : ""
                }`}
                key={card.id}
              >
                <img src={card.img} alt={card.id + "-icon"} />
                <h3>{_t(card.titleKey)}</h3>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="landlord-modal-group-btn">
            <button
              className="footer-btn grey-footer-btn"
              onClick={handlePrevStep}
            >
              {_t("back")}
            </button>
            <button
              className="footer-btn lanlord-footer-btn-disabled"
              onClick={handleSubmitForm}
              disabled={!haveValue(formData.landing_source)}
            >
              {_t("next")}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DiscoverySourceModal;
